export interface BlogPost {
    postUrl: string;
    imageUrl: string;
    title: string;
    description: string;
    category: string;
    authorUrl: string;
    authorName: string;
    dateDay: number;
    dateMonth: string;
    backgroundColor: string;
    textColor: string;
    categoryTop: string;
    postId: number;
    seriesId: number;
    route: string;
}

export interface BlogSeries {
    id: string;
    title: string;
    description: string;
    backgroundImage: string;
    backgroundPosition: string;
    youtubeEmbedId?: string;
    youtubeChannel?: string;
    youtubeChannelUrl?: string;
    posts: BlogPost[];
}

export const useBlogData = (seriesId?: string) => {
    const safmcSeries: BlogSeries = {
        id: 'safmc',
        title: 'Singapore Amazing Flying Machine Competition 2023',
        description: 'SAFMC 2023',
        backgroundImage: '',
        backgroundPosition: 'left bottom',
        youtubeEmbedId: '89qinqi1YY0',
        youtubeChannel: 'Aksantara ITB',
        youtubeChannelUrl: 'https://www.youtube.com/@AksantaraITB',
        posts: [
            {
                seriesId: 1,
                postUrl: 'https://rifqifarhansyah.id/',
                imageUrl: '',
                title: '2 Months Preparation for SAFMC 2023 (Part 1)',
                description: 'It has always been my dream to participate in an international competition where individuals from various countries gather to discuss and present their work with the aim of achieving victory...',
                category: 'SAFMC 2023',
                authorUrl: 'https://www.rifqifarhansyah.id/',
                authorName: 'Mohammad Rifqi Farhansyah',
                dateDay: 21,
                dateMonth: 'Dec',
                backgroundColor: 'bg-[#f9ad40]',
                textColor: 'text-[#f9ad40]',
                categoryTop: 'top-56',
                postId: 1,
                route: '/safmc/safmc-part1',
            },
            {
                seriesId: 1,
                postUrl: 'https://rifqifarhansyah.id/',
                imageUrl: '',
                title: 'My First Departure Abroad (Part 2)',
                description: 'After long preparation, from registering my self to join ITB`s SAFMC team 2023, learn a lot of new thing, and preparing departure, it was the showtime...',
                category: 'SAFMC 2023',
                authorUrl: 'https://www.rifqifarhansyah.id/',
                authorName: 'Mohammad Rifqi Farhansyah',
                dateDay: 23,
                dateMonth: 'Dec',
                backgroundColor: 'bg-[#f9ad40]',
                textColor: 'text-[#f9ad40]',
                categoryTop: 'top-48',
                postId: 2,
                route: '/safmc/safmc-part2',
            },
            {
                seriesId: 1,
                postUrl: 'https://rifqifarhansyah.id/',
                imageUrl: '',
                title: 'D1 - Semi Autonomous Drone Competition (Part 3)',
                description: 'Tomorrow is quite a tense day for us as we will be participating in the competition in the D1 category – Semi Autonomous Drone at the Science Center, Singapore...',
                category: 'SAFMC 2023',
                authorUrl: 'https://www.rifqifarhansyah.id/',
                authorName: 'Mohammad Rifqi Farhansyah',
                dateDay: 24,
                dateMonth: 'Dec',
                backgroundColor: 'bg-[#f9ad40]',
                textColor: 'text-[#f9ad40]',
                categoryTop: 'top-48',
                postId: 3,
                route: '/safmc/safmc-part3',
            },
            {
                seriesId: 1,
                postUrl: 'https://rifqifarhansyah.id/',
                imageUrl: '',
                title: 'D2 - Autonomous Drone Competition (Part 4)',
                description: 'Yesterday was a quite long day, but the most important thing is that we only need to focus on the D2 – Autonomous Drone category that will take place today...',
                category: 'SAFMC 2023',
                authorUrl: 'https://www.rifqifarhansyah.id/',
                authorName: 'Mohammad Rifqi Farhansyah',
                dateDay: 24,
                dateMonth: 'Dec',
                backgroundColor: 'bg-[#f9ad40]',
                textColor: 'text-[#f9ad40]',
                categoryTop: 'top-48',
                postId: 4,
                route: '/safmc/safmc-part4',
            },
            {
                seriesId: 1,
                postUrl: 'https://rifqifarhansyah.id/',
                imageUrl: '',
                title: 'Spend Some Days in Batam (Part 5)',
                description: 'Those tense days have come to an end, and now we are lazyly awaiting the announcement of the results in three days...',
                category: 'SAFMC 2023',
                authorUrl: 'https://www.rifqifarhansyah.id/',
                authorName: 'Mohammad Rifqi Farhansyah',
                dateDay: 24,
                dateMonth: 'Dec',
                backgroundColor: 'bg-[#f9ad40]',
                textColor: 'text-[#f9ad40]',
                categoryTop: 'top-48',
                postId: 5,
                route: '/safmc/safmc-part5',
            },
            {
                seriesId: 1,
                postUrl: 'https://rifqifarhansyah.id/',
                imageUrl: '',
                title: 'Walk Around Singapore - Hello Merlion! (Part 6)',
                description: 'Singapore today feels different from the Singapore I visited a few days ago. Perhaps it`s because the pressure of the competition is no longer weighing on us...',
                category: 'SAFMC 2023',
                authorUrl: 'https://www.rifqifarhansyah.id/',
                authorName: 'Mohammad Rifqi Farhansyah',
                dateDay: 24,
                dateMonth: 'Dec',
                backgroundColor: 'bg-[#f9ad40]',
                textColor: 'text-[#f9ad40]',
                categoryTop: 'top-48',
                postId: 6,
                route: '/safmc/safmc-part6',
            },
            {
                seriesId: 1,
                postUrl: 'https://rifqifarhansyah.id/',
                imageUrl: '',
                title: 'Awarding Ceremony, "Thanks God" (Part 7)',
                description: 'Today is the long-awaited-day. The outcome of all the dedicated efforts we have put in over the past two months will be determined today...',
                category: 'SAFMC 2023',
                authorUrl: 'https://www.rifqifarhansyah.id/',
                authorName: 'Mohammad Rifqi Farhansyah',
                dateDay: 24,
                dateMonth: 'Dec',
                backgroundColor: 'bg-[#f9ad40]',
                textColor: 'text-[#f9ad40]',
                categoryTop: 'top-48',
                postId: 7,
                route: '/safmc/safmc-part7',
            },
        ],
    };

    const aclSeries: BlogSeries = {
        id: 'acl',
        title: 'Association for Computational Linguistics 2025',
        description: 'ACL 2025',
        backgroundImage: '', // Ubah bg image
        backgroundPosition: 'center center',
        youtubeEmbedId: '', // Add YouTube ID jika ada
        youtubeChannel: '', // Add channel name
        youtubeChannelUrl: 'https://youtube.com/...',
        posts: [
            {
                seriesId: 2,
                postUrl: 'https://rifqifarhansyah.id/',
                imageUrl: '',
                title: 'Preparation Before Setting Foot in Europe (Part 1)', 
                description: 'My journey to Europe to attend the ACL 2025 conference has been one of the most joyful and emotionally moving experiences in my life...',
                category: 'ACL 2025',
                authorUrl: 'https://www.rifqifarhansyah.id/',
                authorName: 'Mohammad Rifqi Farhansyah',
                dateDay: 26,
                dateMonth: 'July',
                backgroundColor: 'bg-[#1f72ba]',
                textColor: 'text-[#1f72ba]',
                categoryTop: 'top-56',
                postId: 1,
                route: '/acl/acl-part1',
            },
            {
                seriesId: 2,
                postUrl: 'https://rifqifarhansyah.id/',
                imageUrl: '',
                title: 'First Day in The City of Music—Vienna (Part 2)',
                description: 'Since I was a kid, Amadeus 1984 has always been one of my favorite movies. And today, I finally arrived in the city where that movie was set...',
                category: 'ACL 2025',
                authorUrl: 'https://www.rifqifarhansyah.id/',
                authorName: 'Mohammad Rifqi Farhansyah',
                dateDay: 27,
                dateMonth: 'July',
                backgroundColor: 'bg-[#1f72ba]',
                textColor: 'text-[#1f72ba]',
                categoryTop: 'top-52',
                postId: 2,
                route: '/acl/acl-part2',
            },
            {
                seriesId: 2,
                postUrl: 'https://rifqifarhansyah.id/',
                imageUrl: '',
                title: 'Day-1 Main Conference ACL 2025 (Part 3)',
                description: 'Main Conference ACL 2025, I was really going there, and my paper would be presented there...',
                category: 'ACL 2025',
                authorUrl: 'https://www.rifqifarhansyah.id/',
                authorName: 'Mohammad Rifqi Farhansyah',
                dateDay: 28,
                dateMonth: 'July',
                backgroundColor: 'bg-[#1f72ba]',
                textColor: 'text-[#1f72ba]',
                categoryTop: 'top-52',
                postId: 3,
                route: '/acl/acl-part3',
            },
            {
                seriesId: 2,
                postUrl: 'https://rifqifarhansyah.id/',
                imageUrl: '',
                title: 'My Presentation Day – Main Conference ACL 2025 (Part 4)',
                description: 'The day of my presentation finally arrived. My heart was pounding, and I really hoped nothing weird would happen...',
                category: 'ACL 2025',
                authorUrl: 'https://www.rifqifarhansyah.id/',
                authorName: 'Mohammad Rifqi Farhansyah',
                dateDay: 29,
                dateMonth: 'July',
                backgroundColor: 'bg-[#1f72ba]',
                textColor: 'text-[#1f72ba]',
                categoryTop: 'top-52',
                postId: 4,
                route: '/acl/acl-part4',
            },
            {
                seriesId: 2,
                postUrl: 'https://rifqifarhansyah.id/',
                imageUrl: '',
                title: 'Day 4 ACL – Diversity & Inclusion Lunch (Part 5)',
                description: 'Today is my chance to build connections through the various community events I will be attending...',
                category: 'ACL 2025',
                authorUrl: 'https://www.rifqifarhansyah.id/',
                authorName: 'Mohammad Rifqi Farhansyah',
                dateDay: 31,
                dateMonth: 'July',
                backgroundColor: 'bg-[#1f72ba]',
                textColor: 'text-[#1f72ba]',
                categoryTop: 'top-56',
                postId: 5,
                route: '/acl/acl-part5',
            },
            {
                seriesId: 2,
                postUrl: 'https://rifqifarhansyah.id/',
                imageUrl: '',
                title: 'Exploring the City of Bratislava, Slovakia (Part 6)',
                description: 'Today, Kak Iwan and I decided to visit a city in another country that is even closer than Salzburg from Vienna...',
                category: 'ACL 2025',
                authorUrl: 'https://www.rifqifarhansyah.id/',
                authorName: 'Mohammad Rifqi Farhansyah',
                dateDay: 31,
                dateMonth: 'July',
                backgroundColor: 'bg-[#1f72ba]',
                textColor: 'text-[#1f72ba]',
                categoryTop: 'top-52',
                postId: 6,
                route: '/acl/acl-part6',
            },
            {
                seriesId: 2,
                postUrl: 'https://rifqifarhansyah.id/',
                imageUrl: '',
                title: 'Vienna, One Last Walk (Part 7)',
                description: 'I have been in Vienna for quite a while, but only today did I really get the chance to explore the city more deeply...',
                category: 'ACL 2025',
                authorUrl: 'https://www.rifqifarhansyah.id/',
                authorName: 'Mohammad Rifqi Farhansyah',
                dateDay: 1,
                dateMonth: 'August',
                backgroundColor: 'bg-[#1f72ba]',
                textColor: 'text-[#1f72ba]',
                categoryTop: 'top-52',
                postId: 7,
                route: '/acl/acl-part7',
            },
            {
                seriesId: 2,
                postUrl: 'https://rifqifarhansyah.id/',
                imageUrl: '',
                title: 'Stopping by and roaming around Switzerland (Part 8)',
                description: 'One of the transit countries on my way home was Switzerland, a country I have dreamed of visiting for a long time...',
                category: 'ACL 2025',
                authorUrl: 'https://www.rifqifarhansyah.id/',
                authorName: 'Mohammad Rifqi Farhansyah',
                dateDay: 2,
                dateMonth: 'August',
                backgroundColor: 'bg-[#1f72ba]',
                textColor: 'text-[#1f72ba]',
                categoryTop: 'top-52',
                postId: 8,
                route: '/acl/acl-part8',
            },
            {
                seriesId: 2,
                postUrl: 'https://rifqifarhansyah.id/',
                imageUrl: '',
                title: 'Back to Indonesia (Part 9)',
                description: 'Europe is indeed wonderful, but in my heart, it will always be Indonesia. Nothing can replace it...',
                category: 'ACL 2025',
                authorUrl: 'https://www.rifqifarhansyah.id/',
                authorName: 'Mohammad Rifqi Farhansyah',
                dateDay: 3,
                dateMonth: 'August',
                backgroundColor: 'bg-[#1f72ba]',
                textColor: 'text-[#1f72ba]',
                categoryTop: 'top-52',
                postId: 9,
                route: '/acl/acl-part9',
            },
        ],
    };

    // PENTING: Return HANYA series yang diminta
    if (seriesId === 'safmc') {
        return { blogSeries: [safmcSeries] };
    }
    if (seriesId === 'acl') {
        return { blogSeries: [aclSeries] };
    }

    // Default return empty jika tidak ada seriesId
    return { blogSeries: [] };
};